// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from "./registerServiceWorker";
import './styles/base/typography.module.css';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import 'swiper/components/effect-fade/effect-fade.scss';
import './styles/base/swiper.css';

import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
